<template>
  <div>
    <v-app-bar
      app
      height="80"
      class="white px-4"
      elevation="1"
      v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-row
        no-gutters
        align="center"
        justify="space-between"
        class="fill-height"
      >
        <v-col cols="auto">
          <v-img src="@/assets/images/logo_pitch.webp" contain width="50" />
        </v-col>

        <v-col cols="auto" v-for="(item, i) in filteredMenuItems" :key="i">
          <v-hover v-slot="{ hover }">
            <v-btn
              plain
              ripple
              @click="scrollToSection(item.section || item.link)"
              :style="{ color: hover ? '#e8276f' : '' }"
              class="text-capitalize font-weight-bold"
              style="font-size: 15px; font-family: 'Poppins', sans-serif"
            >
              {{ item.text }}
            </v-btn>
          </v-hover>
        </v-col>

        <v-col cols="auto">
          <v-hover v-slot="{ hover }">
            <v-btn
              class="white--text text-capitalize"
              @mouseover="loginText = 'Em breve'"
              @mouseleave="loginText = 'Pitch Connect'"
              depressed
              rounded
              color="primary"
              min-width="180"
              style="font-weight: bolder; font-family: 'Poppins', sans-serif"
            >
              <v-icon left size="20">
                {{ hover ? "mdi-lock-open-outline" : "mdi-lock-outline" }}
              </v-icon>
              {{ loginText }}
            </v-btn>
          </v-hover>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-app-bar fixed v-else elevation="1" color="white">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-img src="@/assets/images/logo_pitch.webp" contain max-width="40" />
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list nav dense>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          link
          @click="scrollToSection(item.section)"
        >
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "TopMenu",
  data() {
    return {
      drawer: false,
      loginText: "Pitch Connect",
      menuItems: [
        { text: "A Pitch Connect", section: "metodologia" },
        { text: "Diferencial", section: "diferencial" },
        { text: "FAQ", section: "faq" },
        { text: "Fale conosco", link: "whatsapp" }, // Exemplo de identificador
        { text: "Seja professor licenciado", section: "seja-licenciado" },
      ],
    };
  },
  computed: {
    filteredMenuItems() {
      // Retorna apenas os itens que você quer no desktop (opcional)
      return this.menuItems;
    },
  },
  methods: {
    scrollToSection(sectionId) {
      if (sectionId === "whatsapp") {
        window.open(
          `https://api.whatsapp.com/send?phone=5532991934626`,
          "_blank"
        );
        return;
      }
      if (sectionId === "seja-licenciado") {
        this.$router.push("/seja-licenciado");
      } else {
        this.$emit("scroll", sectionId);
      }
      this.drawer = false;
    },
  },
};
</script>
